import { Button, Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";
import { Link, useLoaderData } from "react-router";
import invariant from "tiny-invariant";

import { LateProjectionData, ProjectionsChart } from "@/components/Trajectory";
import Card from "@/components/ui/Card";
import { TCategoryProjections } from "@/types";

export async function loader() {
  const categoryProjectionsResponse = await fetch(
    "/api/client/trajectories/category_projections"
  );

  if (categoryProjectionsResponse.status !== 200) {
    return { error: true };
  }

  const { data: categoryProjectionsData } =
    (await categoryProjectionsResponse.json()) as {
      data: TCategoryProjections;
    };

  return { categoryProjections: categoryProjectionsData };
}

function TrajectorySummary() {
  const { categoryProjections } = useLoaderData<typeof loader>();
  const { t } = useTranslation(["common", "trajectory"]);

  invariant(categoryProjections, "No category projections found!");

  const years = Object.keys(Object.values(categoryProjections)[0]);
  invariant(years.length >= 1, "No projection year found for this category!");

  return (
    <Card>
      <Typography as="h1" step="2" weight="bold">
        {t("trajectory:summary.title")}
      </Typography>
      <LateProjectionData categoryProjections={categoryProjections} />
      <ProjectionsChart categoryProjections={categoryProjections} />
      <div className="mt-xl gap-x-md flex justify-center">
        <Button as={Link} to="/trajectory/creation/projections" shape="outline">
          {t("common:back")}
        </Button>
        <Button as={Link} to="/trajectory/creation/build-action-plan">
          {t("common:continue")}
        </Button>
      </div>
    </Card>
  );
}

export default TrajectorySummary;
